<template>
  <div
    class="s-plan-details-comp s-transition-01"
    :class="[ planName,
              {'subscribed' : isSubscribed},
              {'selected' : isSelected},
              {'current-plan' : currentPlan},
            ]"
    @click="isSubscribed ? '' : $emit('planSelected')">

    <s-icon
      v-if="isSubscribed"
      class="subscribed-icon"
      :class="planName" icon-font="s-icon-ok" circle></s-icon>

    <section class="s-plan-details-name s-no-select">
      <s-icon :icon-font="planNameIconPath" :icon-image="planName !== 'trial' ? planNameIconPath : ''"></s-icon>
      <div class="s-plan-details-name-title ">
        <h1 >{{ planNameTitle }} <s-icon v-if="planName !== 'trial' && planName !== 'lite' && currentPlan" icon-font="s-icon-premium"></s-icon></h1>
        <span v-if="isSubscribed">{{ $t('plans-container.subscribed-title')}}</span>
        <span v-if="isSelected">{{ $t('plans-container.selected-title')}}</span>
      </div>

    </section>

    <section class="s-plan-badge s-no-select">
      <div v-if="isSubscribed" class="badge-current-plan">
        <span>{{ $t('plans-container.current-plan-title') }}</span>
      </div>
      <div v-if="planName === 'pro'" class="badge-most-popular">
        <span><s-icon icon-font="s-icon-star"></s-icon>{{ $t('plans-container.most-popular-title') }}</span>
      </div>
    </section>

    <section class="s-plan-price s-no-select">
      <span v-if="planName !== 'trial'">$</span>
      <span>{{ !togglePrice ? planPriceMonthly : planPriceAnnually }}<sup v-if="planName !== 'trial'">95</sup></span>
      <br v-if="togglePrice">
      <span v-if="togglePrice" class="badge-save">{{ $t('plans-container.save-title') }} {{ saveAnnually }}</span>
    </section>

    <s-icon v-if="isSelected" class="selected-icon" icon-font="s-icon-ok" circle></s-icon>
  </div>
</template>

<script>
import SIcon from "@/components/SIcon.vue";

export default {
  components: {
    SIcon
  },
  props: {
    planName: {
      type: String,
      default: '',
    },
    isSubscribed: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    currentPlan: {
      type: Boolean,
      default: false,
    },
    togglePrice: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['planSelected'],
  data() {
    return {
    };
  },
  computed: {
    planNameTitle() {
      if (this.planName === 'trial') return this.$t('plans-container.name.trial-title')
      if (this.planName === 'lite') return this.$t('plans-container.name.lite-title')
      if (this.planName === 'basic') return this.$t('plans-container.name.basic-title')
      if (this.planName === 'pro') return this.$t('plans-container.name.pro-title')
      if (this.planName === 'master') return this.$t('plans-container.name.master-title')
      return '';
    },
    planNameIconPath() {
      if (this.planName === 'trial') return 's-icon-clock-thin'
      if (this.planName === 'lite') return 'SVG/plan_lite_logo_SVG.svg'
      if (this.planName === 'basic') return 'SVG/plan_basic_logo_SVG.svg'
      if (this.planName === 'pro') return 'SVG/plan_pro_logo_SVG.svg'
      if (this.planName === 'master') return 'SVG/plan_master_logo_SVG.svg'
      return '';
    },
    planPriceMonthly() {
      if (this.planName === 'trial') return 'Free'
      if (this.planName === 'lite') return '2'
      if (this.planName === 'basic') return '6'
      if (this.planName === 'pro') return '9'
      if (this.planName === 'master') return '19'
      return '';
    },
    planPriceAnnually() {
      if (this.planName === 'trial') return 'Free'
      if (this.planName === 'lite') return '2'
      if (this.planName === 'basic') return '69'
      if (this.planName === 'pro') return '99'
      if (this.planName === 'master') return '199'
      return '';
    },
    saveAnnually() {
      if (this.planName === 'basic') return '$13.90'
      if (this.planName === 'pro') return '$19.90'
      if (this.planName === 'master') return '$39.90'
      return '';
    },
  },
  methods: {
  },
};
</script>
